import { useState } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '@/context/AuthContext'
import { signInWithGoogle } from '@/lib/firebase'

export function Login() {
  const { user, loading } = useAuth()
  const [error, setError] = useState<string | null>(null)
  const [signingIn, setSigningIn] = useState(false)

  if (loading) return null
  if (user) return <Navigate to="/" replace />

  async function handleSignIn() {
    setError(null)
    setSigningIn(true)
    try {
      await signInWithGoogle()
    } catch (e) {
      setError(e instanceof Error ? e.message : 'No se pudo iniciar sesión.')
    } finally {
      setSigningIn(false)
    }
  }

  return (
    <div
      style={{
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        gap: 24,
      }}
    >
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: 18, fontWeight: 500, marginBottom: 4 }}>IT AI Agents Panel</div>
        <div style={{ fontSize: 13, color: 'var(--text-secondary)' }}>Connect — acceso restringido</div>
      </div>
      <button
        onClick={handleSignIn}
        disabled={signingIn}
        style={{
          background: 'var(--surface)',
          border: '1px solid var(--border-strong)',
          color: 'var(--text-primary)',
          borderRadius: 'var(--radius-md)',
          padding: '10px 20px',
          fontSize: 14,
          cursor: signingIn ? 'default' : 'pointer',
          opacity: signingIn ? 0.6 : 1,
        }}
      >
        {signingIn ? 'Entrando…' : 'Entrar con Google'}
      </button>
      {error && <div style={{ fontSize: 13, color: 'var(--status-error)', maxWidth: 320, textAlign: 'center' }}>{error}</div>}
    </div>
  )
}
